/*
 * Copyright (c) 2022. Haodong JU
 */

import i18n from '../../i18n'
import hillo from 'hillo'
import { isEmpty, isNumber } from 'lodash'
import { showSuccessMessage, sureTo } from '@/common/utils'
import GlobalConfig from '@/GlobalSettings'

const config = require('@/assets/config.json')

export function isNotBlank (val) {
  return !isEmpty(val) || isNumber(val)
}

export function isBlank (val) {
  return isEmpty(val) && !isNumber(val)
}

export const getIndexData = function () {
  return hillo.get('IndexData.php', {
    lang: GlobalConfig.lang,
  }, {
    timeout: 90 * 1000,
  })
}

export const rejectTakeAwayOrder = function (reason, tableId) {
  return hillo.post('Complex.php', {
    op: 'rejectTakeAwayOrder',
    reason: reason,
    tableId: tableId,
  })
}

export const printSummaryBon = function (filter) {
  return hillo.post('Complex.php?op=printSummary', { ...filter })
}
export const printRealTimeSalesBon = function (timeSpan, dishCategoryIds) {
  if (!timeSpan) {
    return []
  }
  if (!timeSpan.length || timeSpan.length < 2) {
    return []
  }
  const [timeStart, timeEnd] = timeSpan
  return hillo.post('BackendData.php?op=printRealTimeSalesBon', {
    timeStart: timeStart,
    timeEnd: timeEnd,
    dishCategoryIds: dishCategoryIds,
  })
}
export const printRealTimeAttributeSalesBon = function () {
  return hillo.post('BackendData.php?op=PrinterRealTimeAttributeSaleBon')
}

export async function printZBon () {
  await sureTo(async () => {
    await sureTo(async () => {
      await hillo.post('ZBon.php?op=printZbon', {
        forceCloseTable: 1,
        sendToMail: 1,
      })
      showSuccessMessage('Erfolgreich drucken!')
    }, '请注意，打印ZBon会强制结掉所有当前开的桌子，如果当前有还开着的桌子，那么打印ZBon将会让这些桌子变成未结单状态。这是最后一次确认，如果点击确认，则不能恢复。')
  }, '请注意，您现在正在打印ZBon，打印ZBon会结掉所有当前开着的桌子。这是第一次确认。')
}

export async function print3In1Today () {
  return await hillo.post('BackendData.php?op=print3In1Today')
}

export async function previewZBon (startDate, endDate) {
  return (await hillo.get('ZBon.php?op=previewBySpan', {
    startDate,
    endDate,
  })).content
}

export async function printXBon (startDate, endDate) {
  return (await hillo.post('Complex.php?op=printSummary', {
    timespan: startDate + ' - ' + endDate,
  })).content
}

export const getDetailOrder = function (id) {
  return hillo.get('BackendData.php', {
    // params: {
    op: 'billDetail',
    lang: i18n.locale.toUpperCase(),
    id: id, // },
  })
}
export const checkServant = function (pw, tableId) {
  return hillo.get('Servant.php', {

    op: 'checkServant',
    pw: pw,
    tableId: tableId,

  })
}
export const removeAllData = function (payMethod, id) {
  return hillo.post('Complex.php', {
    op: 'removeAllData',
    payMethod: payMethod,
    id: id,
  })
}

export const manageCashAccount = function (amount, note = '', isDatevAccountRef = null) {
  return hillo.post('Complex.php?op=manageCashAccount', {
    datevAccountRef: isDatevAccountRef,
    amount: amount,
    note: note,
  })
}
export const getCurrentCashAmount = async function () {
  return (await hillo.get('Complex.php?op=getCurrentCashAmount')).content?.currentCashAmount ?? 0
}
export const printServantSummaryBon = function (id, start, end) {
  return hillo.get('Servant.php', {
    op: 'printSummaryBon',
    id: id,
    start: start,
    end: end,
  })
}

export const Login = function (password) {
  return hillo.get(config.companyRoot, {
    op: 'logIn',
    password: password,
  })
}

export const reprintOrder = function (id, withTitle = 0, printCount = 1) {
  return hillo.post('BackendData.php?op=reprintOrder', {
    id,
    withTitle,
    printCount,
  })
}

export const findBestIp = function (id) {
  return hillo.get(config.companyRoot, {
    op: 'findBestIp',
    deviceId: id,
  })
}
export const getRestaurantInfo = function () {
  return hillo.get('Restaurant.php?op=view')
}

export async function getNiceRestaurantInfo () {
  return (await hillo.get('Restaurant.php?op=view')).content[0]
}

export const updateRestaurantInfo = function (item) {
  return hillo.post('Restaurant.php?op=update', {
    ...item,
    showloading: true,
  })
}
export const sendMsg = function (title, content) {
  return hillo.post('Complex.php?op=sendEmailToUS', {
    title: title,
    content: content,
  })
}

export const addMultipleTable = function (sectionId, start, end, digit, seatCount) {
  return hillo.post('Tables.php?op=massAddSpan', {
    sectionId: sectionId,
    start: start,
    end: end,
    digit: digit,
    seatCount: seatCount,
  })
}
export const reprintZbon = function (id) {
  return hillo.post('ZBon.php?op=reprintZbon', {
    id: id,
  })
}

export const getOneMemberCardDetail = function (id) {
  return hillo.get('MemberCard.php?', {
    op: 'GetMemberCardDetail',
    id: id,
  })
}

export const printAllQR = function () {
  return hillo.get('QRGen.php?op=printAllQR')
}

export const getRealTimeSaleData = function (timeSpan) {
  if (!timeSpan) {
    return []
  }
  if (!timeSpan.length || timeSpan.length < 2) {
    return []
  }
  const [timeStart, timeEnd] = timeSpan
  return hillo.get('BackendData.php?', {
    op: 'getRealTimeSaleData',
    timeStart: timeStart,
    timeEnd: timeEnd,
    lang: i18n.locale.toUpperCase(),
  })
}

export const getDailyZbon = function (timeSpan) {
  if (!timeSpan) {
    return []
  }
  if (!timeSpan.length || timeSpan.length < 2) {
    return []
  }
  const [startDate, endDate] = timeSpan
  return hillo.get('ZBon.php?', {
    op: 'previewBySpan',
    startDate: startDate,
    endDate: endDate,
  })
}

export const printZbonBySpan = function (timeSpan, printByDay) {
  if (!timeSpan) {
    return []
  }
  if (!timeSpan.length || timeSpan.length < 2) {
    return []
  }
  const [startDate, endDate] = timeSpan
  return hillo.post('ZBon.php?op=printZbonBySpan', {
    startDate: startDate,
    endDate: endDate,
    printByDay: printByDay,
  })
}

export const getDishesDiscountRuleList = function () {
  return hillo.get('DiscountRule.php?', {
    op: 'getDishesDiscountRuleList',
  })
}

export const updateDishesDiscountRule = function (dishesRuleList) {
  return hillo.post('DiscountRule.php?op=updateDishesDiscountRule', {
    dishIdDishRulePairs: JSON.stringify(dishesRuleList),
  })
}

export const getAllDishes = function () {
  return hillo.get('Dishes.php?', {
    lang: i18n.locale.toUpperCase(),
  })
}

export const removeCategoryImage = function (id) {
  return hillo.post('Category.php?', {
    op: 'removeCategoryImage',
    id: id,
  })
}

export async function showAllDatevSettings () {
  return (await hillo.get('Datev.php?op=showAllDatevSettings')).content
}

export const updateDatevSettings = function (settings) {
  return hillo.post('Datev.php?op=updateDatevSettings', {
    settings: JSON.stringify(settings),
  })
}

export const exportDatevCsv = function () {
  return hillo.get('Datev.php?', {
    op: 'exportDatevCsv',
  })
}

export const autoSendDatevCsv = function () {
  return hillo.get('Datev.php?', {
    op: 'autoSendDatevCsv',
  })
}

export const sendDatevCSVtoReceiver = function () {
  return hillo.get('Datev.php?op=autoSendDatevCsv', {})
}

export const exportCSVFromTo = function (item) {
  return hillo.post('ExportCSV.php?op=timeSelectCsv', { ...item }, {
    responseType: 'blob',
    timeout: 150 * 1000,
  })
}

export async function sendCsvToEmail (startTime, endTime) {
  return await hillo.post('ExportCSV.php?op=timeSelectCsvToEmail', {
    startTime,
    endTime,
  })
}

export const sendZBonThroughEmail = function (item) {
  return hillo.post('ZBon.php?op=exportZBonByDaySpan', { ...item })
}

export async function getBillListForServant (pw = null, date, lang) {
  return (await hillo.get('BackendData.php?op=mobileV3StatWithLang', {
    pw,
    date,
    lang,
  })).content
}

export async function getServant (id) {
  const res = (await hillo.get('Servant.php', { id })).content
  return res
}
